import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";
import "@fancyapps/fancybox";
import { axiosInstance } from "../../Config";

const UserSubscriptionList = () => {
    const user_subscription = 1;
    const [subscriptions, setSubscriptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const limit = 10;

 useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm.trim());
        }, 500);

        return () => clearTimeout(t);
    }, [searchTerm]);

    useEffect(() => {
        fetchData(currentPage, searchTerm);
    }, [currentPage, debouncedSearchTerm]);

    const fetchData = async (page, search = "") => {
        setLoading(true)
        try {
            const response = await axiosInstance.get(
                `/getAllSubscription?page=${page}&limit=${limit}&user_subscription=${user_subscription}&search=${encodeURIComponent(
                    search
                )}`
            );

            if (response.data.success) {
                setSubscriptions(response?.data?.body?.data);
                setTotalPages(response?.data?.body?.totalPages);

            } else {

            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };




    const handleViewDetails = (subscription) => {
        setSelectedSubscription(subscription);
    };

    return (
        <>
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="title-box mb-3 pb-1">
                                <h4 className="mb-0 page-title">User Subscription List</h4>
                                <nav aria-label="breadcrumb" className="mt-1">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard" className="new">
                                                <i className="ri-home-4-fill me-1" /> Home
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/usersubscriptionlist" className="new">
                                                 User Subscription
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            User Subscription Listings
                                        </li>
                                    </ol>
                                </nav>
                            </div>

                            <div className="card">
                                <div className="card-body cusbar">

                                    <div className="card-head mb-3 d-flex justify-content-between align-items-center">
                                        <div className="d-flex">
                                            <div className="tbl-search position-relative me-2">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search.."
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                />
                                                <i className="ri-search-line" />
                                            </div>


                                        </div>

                                    </div>


                                    <div className="table-responsive table-card border-top">
                                        <div
                                            data-simplebar=""
                                            className="cus-scroll scmob"
                                        >
                                            <table className="table table-centered cus-nowrap align-middle hltr mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr no.</th>
                                                        <th>Name</th>
                                                        <th>Email</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Status</th>
                                                        <th className="text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {subscriptions.length > 0 ? (
                                                        subscriptions.map((subscription, index) => (
                                                            <tr key={subscription?.id}>
                                                                <td>{(currentPage - 1) * limit + index + 1}</td>
                                                                <td>{subscription?.subscribedUser?.name}</td>
                                                                <td>{subscription?.subscribedUser?.email}</td>

                                                                <td>{subscription?.start_date}</td>
                                                                <td>{subscription?.end_date}</td>
                                                                <td>{subscription?.status == 0 ?
                                                                    "Inactive" :
                                                                    subscription?.status == 1 ?
                                                                        "Active" : ""
                                                                }</td>

                                                                <td>
                                                                    <div className="d-flex justify-content-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-soft-primary px-2 btn-sm me-1"
                                                                            data-bs-toggle="offcanvas"
                                                                            data-bs-target="#view-details"
                                                                            aria-controls="offcanvasRight"
                                                                            onClick={() => handleViewDetails(subscription)}
                                                                        >
                                                                            <i className="ri-eye-fill font-size-16"></i>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                            !loading && <tr>
                                                            <td
                                                                colSpan="6"
                                                                style={{ textAlign: "center", padding: "20px" }}
                                                            >
                                                                No Subscription found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            {totalPages && totalPages > 1 ?
                                                <div className="d-flex justify-content-center align-items-center mt-3 ">
                                                    <Stack
                                                        spacing={2}
                                                        className="d-flex justify-content-center mt-3"
                                                    >
                                                        <Pagination
                                                            count={totalPages}
                                                            page={currentPage}
                                                            onChange={handlePageChange}
                                                            color="error"
                                                        />
                                                    </Stack>
                                                </div>
                                                : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="offcanvas offcanvas-end rdetails"
                tabIndex="-1"
                id="view-details"
                aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header d-block">
                    <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                            <h5
                                className="offcanvas-title mb-0 me-3 fw-semibold"
                                id="offcanvasRightLabel"
                            >
                                Subscription Details
                            </h5>
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        ></button>
                    </div>
                </div>
                <div className="offcanvas-body">
                    {selectedSubscription ? (
                        <>
                            <table
                                className="table table-borderless"
                                style={{ marginLeft: "-8px" }}
                            >
                                <tbody>
                                    <tr>
                                        <td>User name :</td>
                                        <td className="text-end text-black fw-medium">
                                            {selectedSubscription?.subscribedUser?.name || ""}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>User email :</td>
                                        <td className="text-end text-black fw-medium">
                                            {selectedSubscription?.subscribedUser?.email || ""}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Plan start date :</td>
                                        <td className="text-end text-black fw-medium">
                                            {selectedSubscription?.start_date || ""}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Plan end date :</td>
                                        <td className="text-end text-black fw-medium">
                                            {selectedSubscription?.end_date || ""}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Plan name :</td>
                                        <td className="text-end text-black fw-medium">
                                        {selectedSubscription?.plan_type == 0 ?
                                                                    "Monthly Plan" :
                                                                    selectedSubscription?.plan_type == 1 ?
                                                                        "3 Months Plan":
                                                                         selectedSubscription?.plan_type == 2 ?
                                                                        "6 Months Plan"  : ""
                                                                }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Plan price :</td>
                                        <td className="text-end text-black fw-medium">
                                            ${selectedSubscription?.price || ""}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </>
                    ) : (
                        <div className="text-center py-5">
                            <i className="ri-user-line font-size-48 text-muted"></i>
                            <p className="mt-3 text-muted">No subscription selected</p>
                        </div>
                    )}
                </div>
            </div>
            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border" role="status" style={{ width: '50px', height: '50px', color: "#963F02" }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserSubscriptionList;
